import React, { useEffect, useState } from "react";
import Header from "../component/menu/Header";
import { constants } from "../constant/constants";
import SideMenu from "../component/menu/SideMenu";
import FormHeaderComponent from "../component/FormHeaderComponent";
import { notification, message } from "antd";
import CustomLoader from "../component/menu/CustomLoader";
import { useParams } from "react-router-dom";
import OrderDetailsComponent from "../component/restaurants/orders/OrderDetailsComponent";
import useUserStore from "../stores/store";
import ApiService from "../utils/ApiService";
import { useSocket } from "../hooks/useSocket";
import { getCalculatedPaymentReceiveTypes } from "../services/order-details-service";

export default function OrderDetails() {
  const { user, restaurantSlug } = useUserStore();
  const [api, contextHolder] = notification.useNotification();
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [isOrderLoad, setIsOrderLoad] = useState(false);

  const socket = useSocket(`${process.env.REACT_APP_IMAGE_BASE_URL}`);

  function getOrderDetails() {
    const token = user.token.token;
    ApiService.FETCH_ORDER_DETAILS(orderId, token)
      .then((res) => {
        if (Boolean(res.data) && res.data.code !== 200) {
          message.error(`Something went wrong.
              ${res.data.message}`);
          setIsOrderLoad(false);
          return;
        }
        const totalPaidAmount = res.payload.record.paymentReceiveTypes.reduce((total, item) => total + item.amount, 0);
        setOrder({...res.payload.record, totalPaidAmount, paymentReceiveTypes: getCalculatedPaymentReceiveTypes(res.payload.record)});
        setIsOrderLoad(true);
      })
      .catch((err) => {
        console.error(err);
        setIsOrderLoad(false);
      });
  }
  
  useEffect(() => {
    getOrderDetails();
  }, [orderId]);

  
    /** Socket communication */
    useEffect(() => {
      if (!socket || !restaurantSlug) {
        return;
      }
    
      // Order Update
      socket.on(`${restaurantSlug}-order-list-item-v2`, (data) => {
        if (!data.isNewOrder) {
          getOrderDetails()
        }
      });
      
    }, [socket, restaurantSlug]);
  

  return (
    <div className="flex flex-col bg-[#e5e7eb]">
      {contextHolder}
      <CustomLoader />
      <Header title={""} menu={constants.MENU.ORDER} currentMenuKey={'T_4_S_4'} />
      <div className="flex flex-row bg-prewhite px-[12%]">
        <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.ORDER} />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[80px]">
          <div className="flex flex-col w-full">
            <FormHeaderComponent title={"Order Details"} listRoute="/order" />
            <div className="flex flex-col">
                {
                    isOrderLoad && (
                        <OrderDetailsComponent
                            record={{
                                order: order,
                            }}
                        />
                    )
                }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
